const DEFAULT_PIXEL_IGNORE_ATTRIBUTE = 'data-default-ignore';

/**
 * Default's SDK attaches an email-blur listener to every native form after init.
 * `data-default-ignore` on an ancestor skips that automatic capture.
 *
 * Portaled modals (billing contact, domain verification) render under `document.body`,
 * outside the demo form, so the attribute has to sit on `documentElement`.
 * The demo form still calls `recordFormInteraction` and `submitForm` itself.
 */
export const ignoreAutomaticDefaultPixelFormCapture = () => {
  document.documentElement.setAttribute(DEFAULT_PIXEL_IGNORE_ATTRIBUTE, '');

  return () => {
    document.documentElement.removeAttribute(DEFAULT_PIXEL_IGNORE_ATTRIBUTE);
  };
};
